"use strict";
var ACC;
ACC.cookie = {

    _autoload: [
        "cachePolicyMessageElements",
        "bindPolicyMessageEvents",
        "initPolicyMessage",
        "preventMobileAppCookiesButton"
    ],

    // Add your constants here.
    _constants: {
        CLASS_COOKIE_CLOSE: "cookie-close",
        CLASS_COOKIE_OPEN: "cookie-open"
    },

    // Populate on the fly for cached elements such as multiple use jQuery look-ups.
    _cache: {},

    /**
     * This function prevents the cookie button from opening the cookie and privacy policy pop-up in the mobile app.
     */
    preventMobileAppCookiesButton: function() {
        $('#mobile-ot-sdk-btn').on('click', function(ev) {
            ev.stopImmediatePropagation();
        });
    },

    // Grab anything related to policy handling and cache.
    cachePolicyMessageElements: function() {
        var CP = ACC.cookie;
        var cache = CP._cache;

        cache.$body = $(document.body);
        cache.$searchForm = $("form[name='search_form_TjxSearchBox']");
        cache.$cookieArea = $(".cookie-container");
        cache.$cookieAreaContent = $(".cookie-container #cookiePolicy");
        cache.screenSize = "";
    },

    // Cookie notice handling
    bindPolicyMessageEvents: function(){
        var CP = ACC.cookie;
        var cache = CP._cache;
        var c = CP._constants;
        var SP = ACC.sidepanel;

        $('#cookiePolicy button').click(function(e){
            e.preventDefault();
            CP.create('tjxUser', true, 365);
            cache.$body.addClass(c.CLASS_COOKIE_CLOSE).removeClass(c.CLASS_COOKIE_OPEN);
            cache.$cookieArea.slideUp(400, SP.setPanelsHeight);

            if ($(".searchbox").hasClass('cookieOpened') === false) {
                $(".searchbox").addClass('cookieOpened');
            } else {
                if ($(".searchbox").hasClass('cookieOpened') === true) {
                    $(".searchbox").removeClass('cookieOpened');
                }
            }
        });
    },

    // Returns the height of cookie message if open, otherwise zero.
    getAreaOpenMessageHeight: function() {
        var cache = ACC.cookie._cache;
        var cookieOpenClass = ACC.cookie._constants.CLASS_COOKIE_OPEN;
        return cache.$body.hasClass(cookieOpenClass) ? cache.$cookieArea.height() : 0;
    },

    initPolicyMessage: function() {
        var CP = ACC.cookie;
        var cache = CP._cache;
        var c = CP._constants;

        if(cache.$cookieAreaContent.length) {
            if (!(CP.read('tjxUser'))){
                cache.$body.removeClass(c.CLASS_COOKIE_CLOSE).addClass(c.CLASS_COOKIE_OPEN);
            }else{
                cache.$body.removeClass(c.CLASS_COOKIE_OPEN);
            }
        }
    },

    // Helper function for creating a cookie.
    create: function(name,value,days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            expires = "; expires="+date.toGMTString();
        }
        else {
            expires = "";
        }
        document.cookie = name+"="+value+expires+"; path=/";
    },

    // Helper function for reading a cookie.
    read: function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)===' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }
};
